"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _atOpacity = _interopRequireDefault(require("../../utils/at-opacity"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = palette => {
  const baseWithOpacity = (0, _atOpacity.default)(palette.productBlue);
  return {
    name: "aegean",
    colors: {
      base: palette.productBlue,
      primary: palette.productBlueShade(3),
      secondary: palette.productBlueShade(23),
      tertiary: palette.productBlueShade(43),
      whiteMix: palette.productBlueTint(90),
      withOpacity: baseWithOpacity(0.55),
      hoveredTabKeyline: palette.productBlueTint(30),
      disabled: palette.productBlueTint(40),
      loadingBarBackground: palette.productBlueTint(70)
    },
    stepSequence: {
      completedText: palette.productBlueShade(23)
    }
  };
};

exports.default = _default;